import React from "react";
import { cn } from "./cn";

export function Skeleton({
  className,
  width,
  height,
  borderRadius = "rounded", // Updated from "rounded-DEFAULT" to standard Tailwind
  ...props
}) {
  return (
    <div
      className={cn(
        "animate-pulse bg-neutral-200/60 dark:bg-neutral-800",
        borderRadius,
        className
      )}
      style={{
        width: width,
        height: height,
      }}
      {...props}
    />
  );
}